import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateModules } from "../../actions";
import {
  OsnTextarea,
  Button,
  OsnInputText,
} from "@identitybuilding/idb-react-ui-elements";
import axios from "axios";
import OurWork from "@identitybuilding/idb-react-our-works/dist/components/OurWork";

const OurWorkEdit = (props) => {
  const dispatch = useDispatch();

  let modules = useSelector((state) => state.AdminReducer.modules);
  let data = useSelector((state) => state.AdminReducer.data);

  let [ourWorkTitle, setOurWorkTitle] = useState(data.options.our_work.title);
  let entityCopy = Object.assign({}, data);
  let modulcesCopy = [...modules];

  const handler = (action, keyword) => {
    if (action === "template") {
      entityCopy.options.our_work.template = keyword;
      adminChange(keyword, action);
    }
    if (action === "title") {
      entityCopy.options.our_work.title = keyword;
      adminChange(keyword, action);
    }
    if (action === "theme") {
      entityCopy.options.our_work.theme = keyword;
      adminChange(keyword, action);
    }

    modulcesCopy[props.index].module = (
      <OurWork
        template={entityCopy.options.our_work.template}
        theme={entityCopy.options.our_work.theme}
        ourWork={entityCopy.options.our_work.work}
        title={entityCopy.options.our_work.title}
      />
    );
    dispatch(updateModules(modulcesCopy));
    // setModules(modulcesCopy);
  };
  const adminChange = (props, action) => {
    axios
      .put(
        `https://onepage-78a00-default-rtdb.europe-west1.firebasedatabase.app/data/data/options/our_work.json`,
        {
          [action]: props,
          ...entityCopy.options.our_work,
        }
      )
      .then(async (resp) => {
      });
  };

  return (
    <div className="testBlock">
      <div className="testTitle">Our work</div>
      <div>
        <span>Title:</span>
        <OsnInputText
          onChange={(e) => setOurWorkTitle(e.target.value)}
          value={ourWorkTitle}
          placeholder={ourWorkTitle}
        />
        <Button
          bgColor={["cn"]}
          size="S"
          text="Change title"
          txtColor="white"
          type="main"
          onClick={() => handler("title", ourWorkTitle)}
        />
      </div>
      <div>
        <span>Template:</span>
        <ul>
          <li onClick={() => handler("template", 1)}>1</li>
          <li onClick={() => handler("template", 2)}>2</li>
        </ul>
      </div>
      <div>
        <span>Theme:</span>
        <ul>
          <li onClick={() => handler("theme", "dark")}>dark</li>
          <li onClick={() => handler("theme", "light")}>light</li>
        </ul>
      </div>
    </div>
  );
};

export default OurWorkEdit;
